import { orchestrator } from "satcheljs";

import { loadCollaboratorsLocationsSucceeded } from "places-explore-operations";
import { isCurrentDateRangeForCollaborators } from "../utils/isCurrentDateRangeForCollaborators";
import { setCollaboratorsLocationsValue } from "../utils/setCollaboratorsLocationsValue";

orchestrator(loadCollaboratorsLocationsSucceeded, ({ result, dateRange }) => {
    if (isCurrentDateRangeForCollaborators(dateRange)) {
        // setting to store
        setCollaboratorsLocationsValue(result.collaboratorScheduleWithLocation);
    }
});
